import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

const lisbonImage = require('../images/lisbon-2.jpg');
const stockholmImage = require('../images/stockholm-poster.jpg');
const phnomPenhImage = require('../images/undp-calibration.jpg');
const kigaliImage = require('../images/kigali-ampersand.jpg');
const kathmanduImage = require('../images/kath.jpg');
const quitoImage = require('../images/quito.jpg');
const buenosAiresImage = require('../images/features-share-image.jpg');
const nairobiImage = require('../images/mockup-image.jpg');
const mendozaImage = require('../images/mendoza.jpg');
// const beloHorizonteImage = require('../images/belo-horizonte.jpg');

const groups = [
  {
    title: 'Urban Pathways',
    description: [
      'We worked with UN-Habitat and the University of Helsinki as part of the Urban Pathways project to increase local capacity in assembling, deploying, and maintaining open-seneca sensor networks and to provide highly granular air quality data for city decision support systems.',
      'As part of the project, we deployed sensors in Kigali, Quito, and Kathmandu.',
    ],
    projects: [
      {
        name: 'Kigali',
        image: kigaliImage,
        imageAlt: 'open-seneca deployment in Kigali',
        facts: ['20 sensors', 'September to October 2021'],
        body: 'Collaborating with the Urban Electric Mobility Initiative, the University of Rwanda, the City of Kigali, and Ampersand Rwanda Ltd, we mounted sensors on Ampersand electric motorbikes to monitor air quality throughout daily delivery-driver commutes.',
        links: [
          {
            label: 'Map',
            href: 'https://maps.open-seneca.org/city/kigali',
          },
          {
            label: 'Publication',
            href: 'https://www.nature.com/articles/s44407-025-00038-1',
          },
        ],
      },
      {
        name: 'Kathmandu',
        image: kathmanduImage,
        imageAlt: 'open-seneca deployment in Kathmandu',
        facts: ['17 sensors', 'October 2021'],
        body: 'We worked with Green Decision Labs and Research, Kathmandu University, Sajha Yatayat Cooperative Limited, and Cycle City Network Nepal to deploy sensors across walking, bicycles, motorcycles, buses, and minibuses.',
      },
      {
        name: 'Quito',
        image: quitoImage,
        imageAlt: 'open-seneca deployment in Quito',
        facts: ['20 sensors', 'September 2021'],
        body: 'Collaborating with the Environment Secretariat of the Municipality of Quito, the Escuela Politecnica Nacional, and Plural Consultora, we deployed sensors to volunteering cyclists, professional bike messengers, and cycling police officers.',
        links: [
          {
            label: 'Workshop and launch',
            href: 'https://www.quitoinforma.gob.ec/2021/09/10/red-urbana-de-ciclistas-se-unen-al-monitoreo-de-la-calidad-de-aire-en-quito/',
          },
        ],
      },
    ],
  },
  {
    title: 'C40 Women4Climate',
    description: [
      'After winning the C40 Women4Climate Tech Challenge 2020 competition, we deployed a network of sensors in Lisbon and Stockholm with citizen scientists. The implementation was funded by VELUX and supported by C40 Cities Climate Leadership Group and the local city councils.',
    ],
    links: [
      {
        label: 'Winning pitch',
        href: 'https://www.youtube.com/watch?v=YD6DFh75Oac&ab_channel=C40Cities',
      },
    ],
    projects: [
      {
        name: 'Lisbon',
        image: lisbonImage,
        imageAlt: 'open-seneca deployment in Lisbon',
        facts: ['55 sensors', 'January 2021 to January 2022'],
        body: 'We collaborated with Lisboa Camara Municipal and FabLab Lisboa to assemble and deploy 55 sensors in Lisbon with volunteering cyclists.',
        links: [
          {
            label: 'Map',
            href: 'https://maps.open-seneca.org/city/lisbon',
          },
          {
            label: 'Launch article',
            href: 'https://lisboaparapessoas.pt/en/2021/07/04/open-seneca-lisbon-launch/',
          },
          {
            label: 'News article',
            href: 'https://lisboaparapessoas.pt/en/2021/05/28/open-seneca-lisbon-bike-air-quality/',
          },
        ],
      },
      {
        name: 'Stockholm',
        image: stockholmImage,
        imageAlt: 'open-seneca deployment in Stockholm',
        facts: ['55 sensors', 'January to September 2021'],
        body: 'We collaborated with Stockholms Stad, SLB-analys, Cykelvanligast, and the Students for Sustainability at KTH to assemble and deploy 55 sensors with volunteering cyclists.',
        links: [
          {
            label: 'Map',
            href: 'https://maps.open-seneca.org/city/stockholm',
          },
          {
            label: 'Launch event',
            href: 'https://www.youtube.com/watch?v=VgD2h-V8qq0',
          },
          {
            label: 'News article',
            href: 'https://www.itsinternational.com/its9/feature/personal-sensor-moves-smart-cities-forward',
          },
        ],
      },
    ],
  },
  {
    title: 'Phnom Penh',
    description: [
      'Working in collaboration with the Accelerator Labs at UNDP Cambodia, the Cambodian Ministry of Environment, and a local school, we piloted a network of 21 sensors, combining fixed and mobile units, to monitor air quality in targeted areas of Phnom Penh.',
      'The students analysed and added local meaning to the collected hyper-local air quality data, complementing the measurements with their knowledge of the city landscape and activities.',
    ],
    projects: [
      {
        name: 'Phnom Penh pilot',
        image: phnomPenhImage,
        imageAlt: 'open-seneca pilot in Phnom Penh',
        facts: ['21 sensors', 'Fixed and mobile units'],
        body: 'The pilot focused on targeted areas of Phnom Penh and paired the data collection with local interpretation from participating students and partners.',
      },
    ],
  },
  {
    title: 'Argentina',
    description: [
      'We worked closely with the Secretary for Environment and Sustainable Development of Argentina, the UNDP Buenos Aires Accelerator Lab, and Buenos Aires city council in multiple pilots.',
      'The first pilot in Buenos Aires ran with 20 sensors for seven weeks in May and June 2019, and the city maps highlighting hotspots of air pollution were presented in early July 2019. The sensors were later moved to different cities, including Mendoza and Cordoba, to continue mapping air quality street by street for the first time, and were later redeployed in Buenos Aires to monitor the effect of COVID-19 lockdown on air pollution.',
    ],
    projects: [
      {
        name: 'Buenos Aires',
        image: buenosAiresImage,
        imageAlt: 'open-seneca deployment in Buenos Aires',
        facts: ['20 sensors', 'May to June 2019'],
        body: 'The first pilot produced city maps of air pollution hotspots and laid the groundwork for later deployments across Argentina, including follow-up monitoring during the COVID-19 lockdown period.',
      },
      {
        name: 'Mendoza & Cordoba',
        image: mendozaImage,
        imageAlt: 'open-seneca deployment in Mendoza',
        facts: ['Follow-on deployment'],
        body: 'Sensors were redeployed in Mendoza and Cordoba to extend the street-by-street mapping work beyond Buenos Aires.',
      },
    ],
  },
  {
    title: 'Nairobi',
    description: [
      'Our air quality sensors were co-created and built in collaboration with the Nairobi Maker Space at the University of Nairobi in summer 2019, and a pilot network was deployed in partnership with UNEP and UN-Habitat, as part of the Urban Pathways project, and delivery companies including Uber Kenya and GetBoda.',
      'In March 2020, ten sensors were mounted on GetBoda delivery motorbikes for one month during the initial stage of lockdown with the support of UN-Habitat. This deployment captured important pre- and post-lockdown air quality data in Nairobi.',
    ],
    links: [
      {
        label: 'Publication',
        href: 'https://iopscience.iop.org/article/10.1088/2515-7620/ac1214',
      },
    ],
    projects: [
      {
        name: 'Nairobi pilot network',
        image: nairobiImage,
        imageAlt: 'open-seneca pilot in Nairobi',
        facts: ['10 sensors on delivery motorbikes', 'March 2020'],
        body: 'The lockdown-period deployment supported comparisons between pre- and post-lockdown air quality conditions while building local maker and partner capacity around the sensor network.',
      },
    ],
  },
  {
    title: 'Belo Horizonte',
    description: [
      'In collaboration with FabLab Newton and supported by the Wuppertal Institute for Climate, Environment and Energy as part of the Urban Pathways project, we piloted online knowledge transfer workshops to scale the open-seneca initiative to cities worldwide.',
    ],
    projects: [
      {
        name: 'Knowledge transfer workshops',
        facts: ['Urban Pathways collaboration'],
        body: 'The Belo Horizonte work focused on remote knowledge sharing and skills transfer rather than a photo-led city deployment.',
      },
    ],
  },
];

function ExternalLinks({ links }) {
  if (!links || !links.length) {
    return null;
  }

  return (
    <div className="mt-6">
      <h4 className="text-sm font-semibold text-gray-500">Relevant links</h4>
      <ul className="mt-3 space-y-2 text-sm text-gray-600">
        {links.map((link) => (
          <li key={link.label}>
            <a className="inline-flex items-center gap-2 font-medium text-gray-700 hover:text-gray-900 transition duration-150 ease-in-out" href={link.href} target="_blank" rel="noopener noreferrer">
              <span>{link.label}</span>
              <FaExternalLinkAlt className="text-xs text-gray-500" aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function ProjectCard({ project }) {
  return (
    <article className="flex flex-col h-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm" data-aos="zoom-y-out">
      <header>
        {project.image && (
          <figure className="relative h-0 pb-3/4 overflow-hidden bg-gray-200">
            <img
              className="absolute inset-0 h-full w-full object-cover"
              src={project.image}
              width="352"
              height="264"
              alt={project.imageAlt}
            />
          </figure>
        )}
        <div className="px-5 pt-5 md:px-6 md:pt-6">
          <h3 className="h3 font-bold text-gray-700">{project.name}</h3>
        </div>
      </header>
      <div className="flex flex-col h-full px-5 pb-5 pt-3 md:px-6 md:pb-6">
        {project.facts && (
          <p className="text-sm uppercase tracking-wider text-gray-500">{project.facts.join(' | ')}</p>
        )}
        <p className="text-lg text-gray-400 mt-4">{project.body}</p>
        <ExternalLinks links={project.links} />
      </div>
    </article>
  );
}

function ProjectGroup({ group }) {
  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <div className="max-w-sm mx-auto md:max-w-none bg-gray-100 shadow-lg rounded overflow-hidden">
        <div className="flex flex-col md:flex-row gap-6 p-8 md:p-12" data-aos="zoom-y-out">
          <div className="w-full">
            <h2 className="h2 text-gray-700">{group.title}</h2>
            <div className="mt-4 space-y-4 text-lg text-gray-500">
              {group.description.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
            <ExternalLinks links={group.links} />
          </div>
        </div>

        <div className="grid gap-8 px-5 pb-6 md:grid-cols-2 md:col-gap-6 md:row-gap-6 md:px-6">
          {group.projects.map((project) => (
            <ProjectCard key={project.name} project={project} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ProjectsListPast() {
  return (
    <section>
      {groups.map((group) => (
        <ProjectGroup key={group.title} group={group} />
      ))}

    </section>
  );
}

export default ProjectsListPast;
